// extracted by mini-css-extract-plugin
module.exports = {"spinnerAnimated":"Spinner_spinnerAnimated__29aYf","rotate":"Spinner_rotate__1aMML","ball1":"Spinner_ball1__11FwQ","ball2":"Spinner_ball2__3LixB"};